import { memo } from "react";
import styled from "styled-components";
import color from "../../../helpers/color";
import transparentize from "../../../helpers/transparentize";
const Mark = /*#__PURE__*/memo(styled.mark.withConfig({
  displayName: "Mark",
  componentId: "sc-10v5a09-0"
})(["background-color:", ";color:", ";"], transparentize, color));
Mark.displayName = "Mark";
Mark.defaultProps = {
  color: "primary"
};
export default Mark;
//# sourceMappingURL=index.js.map